module.exports = "pegasus_template/assets/blocks/header-5-theme2.png";